/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { OmitFunctions } from 'src/core/stores/types';
import {
    QnaMakerMetadataType,
    QnaMakerQnaActiveLearningSuggestion,
    QnaMakerQnaSwagger
} from 'src/qnaMaker/core/services/qnas/QnaMakerAssetsSwaggers';

export type QnaMakerQnaPrompt = {
    displayOrder: number;
    qnaId: number;
    qna?: Partial<QnaMakerQnaSwagger>;
    displayText: string;
};

export class QnaMakerQnaStore {
    public readonly id: number;

    public readonly source: string;

    public readonly isDocumentText: boolean;

    public readonly lastUpdatedDateTime: string;

    @observable public answer: string;

    @observable public questions: string[];

    @observable public activeLearningSuggestions: QnaMakerQnaActiveLearningSuggestion[];

    @observable public metadata: QnaMakerMetadataType;

    @observable public dialog: { isContextOnly: boolean; prompts: QnaMakerQnaPrompt[] };

    constructor(id: number, data: Partial<OmitFunctions<QnaMakerQnaStore>>) {
        this.id = id;
        this.source = data.source;
        this.answer = data.answer;
        this.dialog = data.dialog;
        this.metadata = data.metadata;
        this.questions = data.questions;
        this.activeLearningSuggestions = data.activeLearningSuggestions;
        this.isDocumentText = data.isDocumentText;
        this.lastUpdatedDateTime = data.lastUpdatedDateTime;
    }

    @action
    public setAnswer(ans: string) {
        this.answer = ans;
    }

    @action
    public setQuestions(q: string[]) {
        this.questions = q;
    }

    @action
    public setActiveLearningSuggestions(s: QnaMakerQnaActiveLearningSuggestion[]) {
        this.activeLearningSuggestions = s;
    }

    @action
    public addOrEditMetadata(key: string, value: string) {
        this.metadata[key] = value;
    }

    @action
    public deleteMetadata(key: string) {
        delete this.metadata[key];
    }
}
